import validLicensePresent from "license/ValidLicensePresent";
import EventDefinitionTraffic from "./EventDefinitionTraffic/EventDefinitionTrafficSummary";
import EventDefinitionTrafficForm from "./EventDefinitionTraffic/EventDefinitionTrafficForm";
import EventDefinitionTrafficFormContainer from "./EventDefinitionTraffic/EventDefinitionTrafficFormContainer";
const bindings = {
  eventDefinitionTypes: [
    {
      type: "traffic-v1",
      displayName: "License Usage Monitoring",
      sortOrder: 10,
      description: "Monitor license usage against absolute thresholds or percentage of your billing period limit.",
      formComponent: EventDefinitionTrafficFormContainer,
      summaryComponent: EventDefinitionTraffic,
      defaultConfig: EventDefinitionTrafficForm.defaultConfig,
      useCondition: () => validLicensePresent(),
      hideFieldsStep: true
    }
  ]
};
export default bindings;
